import React from 'react';
import styled from 'styled-components';
import { Dimensions, Font } from 'components/visuals';
import TermsTooltip from 'modules/configure/terms/TermsTooltip';
import { Props } from 'modules/addon/Parent';
import TermsSelect from 'modules/configure/terms/TermsSelect';
import t from 'modules/i18n/intl';
import { checkFeatureGate, FeatureFlags } from 'util/statsig';

const Header = styled.h3`
  display: inline-block;
  font-size: 20px;
  font-family: ${Font.displayFamily};
  font-weight: 500;
  letter-spacing: 0.3px;
  line-height: 24px;
  margin-bottom: ${Dimensions.units(1)}px;
`;

const Wrapper = styled.div`
  margin-top: ${Dimensions.units(2)}px;
  margin-bottom: ${Dimensions.units(2)}px;
  padding-left: 28px;
`;

const ParentTermSelect = ({ data, parent, events }: Props) => {
  const isLimitDCMultiYearContractsFFON = checkFeatureGate(
    FeatureFlags.CART_LIMIT_DC_MULTI_YEAR_CONTRACTS,
  );
  const isDataCenter = data.deploymentOption === 'datacenter';

  return (
    <Wrapper>
      <div>
        <Header>
          {data.isSubscription ? t('addon.subscription-term') : t('addon.maintenance-period')}
        </Header>
        &nbsp;
        <TermsTooltip subscription={data.isSubscription} />
      </div>
      <TermsSelect
        options={
          isLimitDCMultiYearContractsFFON && isDataCenter
            ? parent.terms.filter((term) => term.months !== 24)
            : parent.terms
        }
        selected={parent.term}
        onChange={(term) => events.onTermChange(parent.key, term)}
        currency={data.currency}
      />
    </Wrapper>
  );
};

export default ParentTermSelect;
